import React, {PropTypes} from 'react';


class RhinoCheckbox extends React.Component {

  static defaultProps = {
    disabled: false,
    label: '',
    selected: false,
  };

  static propTypes = {
    changeMethod: PropTypes.func,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    selected: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      selected: this.props.selected,
    };
  }

  componentWillUpdate(nextProps, nextState) {
    if(this.state.selected !== nextProps.selected) {
      this.setState({ selected: nextProps.selected });
    }
  }

  toggleCheckbox() {
    this.setState({ selected: !this.state.selected });
  }

  render() {
    return (
      <div className='RhinoCheckbox'>
        <label className={'control control--checkbox'}>{this.props.label}
          <input 
            type='checkbox' 
            disabled={this.props.disabled} 
            checked={this.state.selected} 
            onClick={::this.toggleCheckbox}
            onChange={::this.props.changeMethod}
            value={this.props.value ? this.props.value : ''} />
          <div className='control__indicator'></div>
        </label>
      </div>
    );
  }
}
export default RhinoCheckbox;


// WEBPACK FOOTER //
// ./src/components/common/inputs/RhinoCheckbox.jsx